import { Component, OnDestroy, OnInit } from '@angular/core';
import { LinkUpService } from '@app/services/link-up/link-up.service';
import { onDestroyComplete } from '@app/sharedModule/decorators/on-destroy-unsubscribe.decorator';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { SettingsService } from '@services/settings/settings.service';
import { UserService } from '@services/user/user.service';
import { LinkUpActions } from '@settings/link-up/store/actions';
import * as fromLinkUpReducer from '@settings/link-up/store/reducers/link-up.reducers';
import { selectLinkUpWorkstations } from '@settings/link-up/store/reducers/link-up.reducers';
import { ToastService } from '@storybook/services/toast/toast.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'link-up',
  templateUrl: './link-up.component.html',
  styleUrls: ['./link-up.component.scss'],
  standalone: false,
})
export class LinkUpComponent implements OnInit, OnDestroy {
  linkUpWorkstations$ = this.store.select(selectLinkUpWorkstations);
  linkUp$ = this.store.select(fromLinkUpReducer.selectLinkUpDetails);
  currentPdqUser$: Observable<PdqUser>;
  desktopClientConnected: boolean = false;
  workstations = [];
  operationSystem: {
    name: string;
    osIcon: string;
  };

  @onDestroyComplete() destroy$ = new Subject();
  constructor(
    private settingsService: SettingsService,
    private userService: UserService,
    private store: Store<fromLinkUpReducer.State>,
    private actions$: Actions,
    private toastService: ToastService,
    public linkUpService: LinkUpService,
  ) {}

  ngOnInit(): void {
    this.operationSystem = this.linkUpService.operationSystem;
    this.currentPdqUser$ = this.userService.currentPdqUser$;
    this.detectFailure();
  }

  ngOnDestroy() {}

  detectFailure() {
    this.actions$
      .pipe(
        takeUntil(this.destroy$),
        ofType(
          LinkUpActions.editLinkUpWorkstationFailure,
          LinkUpActions.editLinkUpDeviceFailure,
          LinkUpActions.deleteLinkUpWorkstationFailure,
        ),
      )
      .subscribe((res) => {
        this.toastService.showToast({ mode: 'danger', message: res.errMsg });
      });
  }

  downloadClient() {
    this.settingsService
      .getLinkUpDownloadClientUrl(this.operationSystem.name)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        window.open(res.linkUpClientUrl);
      });
  }
}
